import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  Output,
  SimpleChanges,
} from '@angular/core';

export interface TabItemLike<T = any> {
  text: string;
  disabled?: boolean;
  data?: T;
}

@Component({
  selector: 'app-tabs',
  templateUrl: 'tabs.component.html',
  styleUrls: ['tabs.component.scss'],
  host: {
    '[class.fill-mode-enabled]': '!!fillModeEnabled',
  },
})
export class TabsComponent implements OnChanges {
  @Input()
  items: TabItemLike[] = [];

  selectedTab: TabItemLike;
  @Output()
  selectedTabChange = new EventEmitter<TabItemLike>(true);

  @Input()
  selectedTabIndex: number = -1;
  @Output()
  selectedTabIndexChange = new EventEmitter<number>(true);

  @Input()
  fillModeEnabled = true;

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.items) {
      const initialTabIndex = this.selectedTabIndex;

      this.selectedTabIndex = !this.items?.length
        ? -1
        : this.items.length < this.selectedTabIndex + 1 ||
          this.selectedTabIndex < 0
        ? 0
        : this.selectedTabIndex;

      this.selectedTab =
        this.selectedTabIndex > -1 ? this.items[this.selectedTabIndex] : null;

      if (this.selectedTabIndex !== initialTabIndex) {
        this.selectedTabIndexChange.emit(this.selectedTabIndex);
      }

      this.selectedTabChange.emit(this.selectedTab);
    }
  }

  onTabItemClick(e, index: number, item: TabItemLike) {
    if (this.selectedTabIndex === index || item.disabled) {
      return;
    }

    this.selectedTabIndex = index;
    this.selectedTab = item;

    this.selectedTabIndexChange.emit(this.selectedTabIndex);
    this.selectedTabChange.emit(this.selectedTab);
  }
}
